export default "__VITE_ASSET__3FU0jD2F__"